import React, { createContext, useContext, useState, useCallback } from 'react';
import { safeStorage } from '@/utils/safariStorage';

interface TourContextType {
  startTour: (tourId: string) => void;
  resetTour: (tourId: string) => void;
  hasSeenTour: (tourId: string) => boolean;
  activeTour: string | null;
  setActiveTour: (tourId: string | null) => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const TourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeTour, setActiveTour] = useState<string | null>(null);

  const hasSeenTour = useCallback((tourId: string) => {
    return safeStorage.getItem(`godyspo_tour_${tourId}`) === 'true';
  }, []);

  const startTour = useCallback((tourId: string) => {
    setActiveTour(tourId);
  }, []);

  const resetTour = useCallback((tourId: string) => {
    safeStorage.removeItem(`godyspo_tour_${tourId}`);
    setActiveTour(tourId);
  }, []);

  return (
    <TourContext.Provider value={{ startTour, resetTour, hasSeenTour, activeTour, setActiveTour }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};
